<template>
  <div class="pb-3">
    <!-- NOTE - THIS IS USED FOR BOTH INTERNAL AND EXTERNAL VIEWS -->

    <ResourceCard
      class="my-5"
      :resource="resource"
      @saved="onUpdatedResource"
    />

    <VendorOnboardingList
      v-if="showOnboarding"
      :resource="resource"
      class="my-5"
    ></VendorOnboardingList>

    <VendorTaggings
      v-if="resource.has_company_tag_categories"
      :company-id="resource.id"
      :selected-tags="resource.company_tags"
      :title="$t('vendorProfile.Categories & Capabilities')"
      @update="onUpdatedResource"
      class="my-5"
    />

    <!-- TODO should probably show one of these per tag group! -->
    <TagFields
      v-if="dynamicTaggingEnabled"
      :title="$t('vendorProfile.Additional Categories & Capabilities')"
      v-model="resource.taggings_by_field"
      :config="taggingConfig"
      class="my-5"
    />

    <!-- maybe just keep all tags, but full serialized versions, with is_featured to know which are featured -->
    <!-- use_vendor_sites tenants: CompanySite instead of CompanyLocation -- internal only (the sites endpoints are internal-only for listing) -->
    <VendorPrimarySiteCard
      v-if="!hideLocations && usesVendorSites && $currentUserInfo.is_internal"
      :company-id="resource.id"
      class="my-5"
    />
    <VendorLocationList
      v-if="!hideLocations && !usesVendorSites"
      :company-id="resource.id"
      class="my-5"
    />
  </div>
</template>

<script>
  import ResourceCard from '@/components/resources/ResourceCard';
  import VendorLocationList from '@/components/vendors/components/VendorLocationList';
  import VendorPrimarySiteCard from '@/components/vendors/components/VendorPrimarySiteCard.vue';
  import VendorTaggings from '../components/VendorTaggings.vue';
  import VendorOnboardingList from '../components/VendorOnboardingList.vue';
  import { currentUserInfoMixin, tenantInfoMixin } from '@/js/custom-vue-mixins';
  import TagFields from '@/components/taxonomy/taggings/TagFields.vue';
  import { suppliosApi } from '@/js/api-service';

  export default {
    components: {
      ResourceCard,
      VendorLocationList,
      VendorPrimarySiteCard,
      VendorTaggings,
      VendorOnboardingList,
      TagFields,
    },
    mixins: [currentUserInfoMixin, tenantInfoMixin],
    props: ['resource', 'hideLocations'],
    i18n: {
      messages: {
        en: {
          vendorProfile: {
            'Categories & Capabilities': 'Categories & Capabilities',
            'Additional Categories & Capabilities': 'Additional Categories & Capabilities',
          },
        },
        es: {
          vendorProfile: {
            'Categories & Capabilities': 'Categorías y Capacidades',
            'Additional Categories & Capabilities': 'Categorías y Capacidades Adicionales',
          },
        },
        pt: {
          vendorProfile: {
            'Categories & Capabilities': 'Categorias e Capacidades',
            'Additional Categories & Capabilities': 'Categorias e Capacidades Adicionais',
          },
        },
        'zh-Hans': {
          vendorProfile: {
            'Categories & Capabilities': '类别和能力',
            'Additional Categories & Capabilities': '其他类别和能力',
          },
        },
        'zh-Hant': {
          vendorProfile: {
            'Categories & Capabilities': '類別和能力',
            'Additional Categories & Capabilities': '其他類別和能力',
          },
        },
      },
    },
    data() {
      return {
        taggingConfig: {
          modelLabel: 'vendors.Company',
          objectId: this.resource.id,
          api: suppliosApi.vendorStandard,
          useInternalEdit: true,
        },
      };
    },
    computed: {
      showOnboarding() {
        const onboardingModuleEnabled = this.$getTenantFlag('show_onboarding');
        const isInternal = this.$currentUserInfo.is_internal;
        return isInternal && onboardingModuleEnabled;
      },
      dynamicTaggingEnabled() {
        return this.$getTenantFlag('taxonomy_vendor_tags', false);
      },
      usesVendorSites() {
        return this.$getTenantFlag('use_vendor_sites', false);
      },
    },
    methods: {
      onUpdatedResource(data) {
        this.$emit('resource:updated', data);
      },
    },
  };
</script>

<style></style>
